import { useHistory, useParams } from 'react-router-dom';
import Button from '../../../forms/inputs/button';
import Summary from '../Components/Summary';
import { usePools } from '../DatabaseContext';
import React, { useEffect } from 'react';
import FormContainer from '../Fields/FormContainer';
import BubbleLoader from '../../../Libraries/Loader/bubble-loader';

export default function SummaryPage({ i18n }) {
    const { id } = useParams()
    const { setPoolId, pool } = usePools()
    const history = useHistory()

    useEffect(() => {
        setPoolId(id)
    }, [id])

    if (!pool) {
        return <BubbleLoader />
    }

    return <FormContainer breadcrumb={[
        { label: pool.name, url: `/${pool.id}/name` },
        { label: i18n.dimensions.heading, url: `/${pool.id}/dimensions` },
        { label: i18n.temperature.heading, url: `/${pool.id}/temperature` },
        { label: i18n.location.heading, url: `/${pool.id}/location` },
        { label: i18n.seasons.heading, url: `/${pool.id}/seasons` },
        { label: i18n.power.heading, url: `/${pool.id}/power` },
        { label: i18n.summary.heading },
    ]} >

        <Summary pool={ pool } i18n={ i18n } />

        <Button className="mt-12" onClick={() => history.push(`/${pool.id}/recommendations`) }>
            { i18n.summary.button }
        </Button>

    </FormContainer>
}
